import React, { useEffect, useState } from "react";
import { images } from "../../assets/index";

import {
  FormInput,
  PageHeading,
  ButtonComp,
  Loader,
} from "../../common/components/index";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import {
  receivedError,
  responseRecived,
  requestSent,
} from "../../redux/actions/utilsActions";

import './user.css'

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getModuleApi } from "../../api/sideBarApi";
import { addUsersApi } from "../../api/users";

const AddUser = () => {
  // Hooks //
  const { userToken, user } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    address: "",
    phone_number: "",
    signatory_on_account: "",
    module: [],
    company_id: user.contractorData.company_id
  });
  const [respMessage, setRespMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [modules, setModules] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [onPageLoader, setOnPageLoader] = useState(false);

  useEffect(() => {
    getModules()
  }, [])

  const getModules = async () => {
    try {
      dispatch(requestSent());
      const data = await getModuleApi(userToken);
      setModules(data.contractor_modules);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
      dispatch(responseRecived());
    }
  }

  // Handler //
  const adduserHendler = async () => {
    try {
      if (
        !formData.fullname ||
        !formData.address ||
        !formData.email ||
        !formData.phone_number ||
        !formData.module.length
      ) {
        alert("!!Please fill all the fields!!");
        return;
      }
      setError("");
      dispatch(requestSent());
      setOnPageLoader(true);
      const data = await addUsersApi(userToken, formData);
      setOnPageLoader(false);
      setRespMessage(data.message);
      dispatch(responseRecived());
      setModalShow(true);
    } catch (error) {
      console.log("Add User Page error::", error);
      dispatch(receivedError(error));
      setError(error);
      setOnPageLoader(false);
      dispatch(responseRecived());
    }
  };

  const modalHendler = () => {
    setModalShow(false);
    navigate("/users");
  };

  const handleSelectFeature = (e) => {
    const moduleId = e.target.value;
    const moduleName = e.target.name;
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedValues(prev => [...prev, moduleName]);

      setFormData({
        ...formData,
        module: [
          ...formData.module,
          moduleId,
        ]
      });
    } else {
      setSelectedValues(prev => prev.filter(p => p !== moduleName))

      setFormData({
        ...formData,
        module: formData.module.filter(m => m !== moduleId)
      });
    }
  };

  // Modal //
  const CustomModal = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Body>
          <div className="allert_img_cont">
            <img src={images.success} alt="" />
            <h2>User Added</h2>
            <p>{respMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button className="orange_btn btn_style" onClick={modalHendler}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  if (onPageLoader) {
    return <Loader />;
  }

  return (
    <>
      <CustomModal />
      <PageHeading title={"Add A New User"} />
      <div id="add-subcontractor" className="right-sec_cont">
        <div>
          <h2>User Details</h2>
          <FormInput
            width={"30vw"}
            lable="Name"
            placeholder={"Enter User Name"}
            onchange={(value) =>
              setFormData({
                ...formData,
                fullname: value,
              })
            }
            value={formData.fullname}
            type={"text"}
            error={error?.error_key === "fullname" ? true : false}
          />
          <FormInput
            width={"30vw"}
            lable="Email"
            placeholder={"Enter Email"}
            onchange={(value) =>
              setFormData({
                ...formData,
                email: value,
              })
            }
            value={formData.email}
            type={"text"}
            error={error?.error_key === "email" ? true : false}
          />

          <FormInput
            width={"30vw"}
            lable="Mobile Number"
            placeholder={"Enter Mobile No."}
            onchange={(value) => {
              setFormData({
                ...formData,
                phone_number: value,
              });
            }}
            value={formData?.phone_number}
            type={"number"}
            error={error?.error_key === "phone_number" ? true : false}
          />

          <FormInput
            width={"30vw"}
            lable="Address"
            placeholder={"Enter Address"}
            onchange={(value) =>
              setFormData({
                ...formData,
                address: value,
              })
            }
            value={formData.address}
            type={"text"}
            error={error?.error_key === "address" ? true : false}
          />

          <div className="w-100">
            <label style={{ fontSize: '16px', marginBottom: '.5rem' }}>Features Allowed:</label> <br />
            <div className="dropdown">
              <button style={{ marginBottom: '.5rem' }} className="btn btn-primary w-100" type="button">Select Features Allowed</button>
              <div className="dropdown-content">
                {
                  modules.map(m => {
                    const moduleId = m.module_type?.id;
                    const moduleName = m.module_type?.name;
                    return (
                      <label>
                        <input type="checkbox" value={moduleId} name={moduleName} onChange={handleSelectFeature} />
                        &nbsp;{moduleName}
                      </label>
                    )
                  })
                }
              </div>
            </div>
            <div className="w-100 d-flex" style={{ flexWrap: 'wrap', maxWidth: '25rem' }}>
              {
                selectedValues.map(sv => {
                  return (
                    <button className="btn btn-primary selected-module-button m-1">
                      {sv}
                    </button>
                  )
                })
              }
            </div>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
              onChange={(e) => setFormData(prev => {
                return {
                  ...prev,
                  signatory_on_account: e.target.checked
                }
              })}
            />
            <label className="form-check-label" for="exampleCheck1">
              Signatory On Account
            </label>
          </div>

          {error ? <p className="err_message">*{error?.error_message}</p> : ""}
          <ButtonComp
            onClick={adduserHendler}
            title={"Add User"}
            width={"30vw"}
          />
        </div>
      </div>
    </>
  );
};

export default AddUser;
